import { configureStore, Store } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import reducer, { middleware } from './rootReducer';

const store: Store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware),
});

export type ThisAppDispatch = typeof store.dispatch;

export const { dispatch } = store;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export const useAppDispatch = () => useDispatch<ThisAppDispatch>();
export type RootState = ReturnType<typeof store.getState>;
export default store;
